import gql from "graphql-tag";

export const GET_ARCHIVE_MENU = gql`
  query archiveYears {
    archiveYears {
      id
      yearTitle
      archive_categroys {
        id
        title

        featuring_image {
          url
        }
      }
    }
  }
`;

export const GET_DETAIL_MENU = gql`
  query archiveSubCategories($where: JSON) {
    archiveSubCategories(where: $where) {
      id
      route_slug
      title
    }
  }
`;

export const GET_ALL_ARCHIVE_MENU = gql`
  query archiveSubCategories {
    archiveCategroys {
      title
      archive_sub_categories {
        title
        route_slug
      }
      featuring_image {
        url
      }
    }
  }
`;
